/**
 * User: Keith
 * Author: Faris
 * Date: 7/6/15
 * Time: 10:30 AM
 */

define('app/views/longpage',['require','./page','text!../../../views/longpage.html'],function(require) {

  var Page = require('./page');  
  var template = require('text!../../../views/longpage.html');

  return Page.extend({
	 template: _.template(template)
  });
});

